
import imageNotFound from "assets/images/imageNotFound.png";

export const startCamera = async ({
    videoRef,
    setShowHeader = () => { },
}) => {
    setShowHeader(false); // Hide header when camera is open
    try {
        const stream = await navigator.mediaDevices.getUserMedia({
            video: {
                facingMode: 'environment',
                height: { ideal: 720 },
                width: { ideal: 1280 },
            },
        });
        if (videoRef.current) {
            videoRef.current.srcObject = stream;
        }
    } catch (err) {
        console.log(`Error: ${err.message}`);
    }
};

export const stopCamera = ({
    videoRef,
    setIsOpenCamera = () => { },
    setShowHeader = () => { },
}) => {
    setIsOpenCamera(false); // Close camera
    setShowHeader(true); // Show header when camera is closed
    if (videoRef.current && videoRef.current.srcObject) {
        const stream = videoRef.current.srcObject;
        stream.getTracks().forEach((track) => track.stop());
    }
}

export const croppedImage = (cropWidth, cropHeight, img) => {

    // Calculate crop position to be centered and middle
    const cropX = (img.width - cropWidth) / 2; // Center horizontally
    const cropY = (img.height - cropHeight) / 2; // Center vertically
    console.log('Crop position:', cropX, cropY);
    // Ensure the crop area fits within the image bounds
    const adjustedCropX = Math.max(0, Math.min(cropX, img.width - cropWidth));
    const adjustedCropY = Math.max(0, Math.min(cropY, img.height - cropHeight));
    // Create a canvas to perform the cropping
    const canvas = document.createElement('canvas');
    canvas.width = cropWidth;
    canvas.height = cropHeight;
    const ctx = canvas.getContext('2d');
    // Draw the cropped portion of the image onto the canvas
    ctx.drawImage(
        img,
        adjustedCropX,
        adjustedCropY,
        cropWidth,
        cropHeight,
        0,
        0,
        cropWidth,
        cropHeight
    );

    return canvas;
}

export const captureImage = ({
    videoRef,
    canvasRef,
    setIsOpenCamera = () => { },
    stopCamera = () => { },
    setImage = () => { },
    _cropWidth = 340,
    _cropHeight = 340
}) => {
    if ('vibrate' in navigator) navigator.vibrate(300);
    if (videoRef.current && canvasRef.current) {
        const canvas = canvasRef.current;
        canvas.width = videoRef.current.clientWidth;
        canvas.height = videoRef.current.clientHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
        const imageData = canvas.toDataURL('image/png');
        setIsOpenCamera(false);
        stopCamera();
        if (imageData) {
            const img = new Image();
            img.src = imageData;
            img.onload = () => {
                const cropWidth = _cropWidth;
                const cropHeight = _cropHeight;
                const croppedCanvas = croppedImage(cropWidth, cropHeight, img);
                const croppedImageUrl = croppedCanvas.toDataURL('image/jpeg', 0.5);
                setImage(croppedImageUrl);
            };
        }
    }
};


export const handleImageError = (e) => {
    console.error("Image failed to load:", e.target.src);
    e.target.onerror = null; // Prevent looping
    e.target.style.objectFit = 'contain'; // Placeholder image
    e.target.src = imageNotFound; // Placeholder image
}